import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App } from './App';
import { TokenProvider } from './auth/TokenContext';
import './styles.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // No background polling — the FiltersBar exposes an explicit Refresh
      // button. Auto-refresh used to live here but was removed once the
      // dashboard's manual workflow matured.
      refetchOnWindowFocus: false,
      staleTime: 15_000,
      retry: 1,
    },
  },
});

const root = document.getElementById('root');
if (!root) throw new Error('#root element not found');

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <TokenProvider>
        <App />
      </TokenProvider>
    </QueryClientProvider>
  </StrictMode>,
);
